/*
Documentation

this file creates a modal to upload missing docs on a case

*/

import DragAndDrop from 'components/functional/uploads/DragAndDrop';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import { toggleAlertBS } from 'store/functions/system/system';

class ModalMissingDocs extends React.Component {

    onUploadStarted = () => {

        this.props.toggleModal();
        toggleAlertBS(false, `Your document is queued for upload and will appear here once it has been processed. Please do not leave or refresh this page for atleast 5 seconds. Note that larger documents may take a few minutes to show up after uploading them.`)
    }

    render() {

        const { missing_doc, showModal, toggleModal } = this.props

        return (

            <Modal
                className="modal-dialog-centered"
                isOpen={showModal}
                toggle={toggleModal}
                size="md"
            >
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">{missing_doc ? missing_doc.name : ''}</h5>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={toggleModal}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body">
                    <p className="text-sm mb-2 font-weight-bold"><i className="fas fa-file mr-2 text-warning " /> Upload 1 File</p>
                    {missing_doc && missing_doc.name ? (
                        <DragAndDrop
                            zone_id="documents_2"
                            url={`/api/v1/core/documents/create`}
                            onError={(e) => console.log(e)}
                            defaultValue={missing_doc.name}
                            uploadOne={true}
                            onUploadStarted={this.onUploadStarted}
                            extraData={{
                                case: this.props.case._id, 
                                contact: this.props.case.contact._id, 
                                finishType: 'template_doc', 
                                templateDocName: missing_doc.name
                            }}
                        />
                    ) : null}
                   
                </div>


            </Modal>

        );
    }
}

const mapStateToProps = state => {
    return {
        viewing_user: state.auth.viewing_user
    };
};

ModalMissingDocs.propTypes = {
    missingDoc: PropTypes.object,


    case: PropTypes.object.isRequired,
    toggleModal: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    onSuccess: PropTypes.func.isRequired
}

export default connect(mapStateToProps, '')(ModalMissingDocs);
